import axios from 'axios'
import { Message } from 'element-ui'
import router from '../../router/index.js'
const axiosInstance = axios.create()
axiosInstance.defaults.timeout = 1000 * 10
axiosInstance.interceptors.request.use(
  config => {
    config.headers.common['Authorization'] = localStorage.getItem('token')
    if(config.url.indexOf('upload/file') > -1){ 
      config.timeout = 1000 * 1800
    }
    return config
  },
  err => {
    console.log(err) // for debug
    return Promise.reject(err)
  }
)
axiosInstance.interceptors.response.use(
  

  response => {
    if (response.data.code !== '0') {
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (response.data.code === '-1000') {
        router.push({ path: '/' })
      }
      if (response.data.code === '-1001') {
        Message({
          message: '暂无权限',
          type: 'error',
          center: true
        })
      }
      if (response.data.code === '-1010') {
        Message({
          message: '重复提交',
          type: 'error',
          center: true
        })
      }
      return response
    } else {
      return response
    }
  },
  error => {
    // 检查请求配置中是否有 skipErrorHandling 标志
    if (error.config && error.config.skipErrorHandling) {
      // 直接拒绝 Promise，不显示错误提示
      return Promise.reject(error);
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default axiosInstance



// WEBPACK FOOTER //
// ./src/api/config/axios.js